import React from "react";
import { Experience } from "../components/Sections/experience/Experience";

const ExperiencePage: React.FC = () => {
  return <Experience showAll />;
};

export default ExperiencePage;
